<script>
export default {
  inject: ["gsap"],
  name: "TitleBanners",
  methods:{
    scrollToForm(){
      if (window.innerWidth <= 700){
        $([document.documentElement, document.body]).animate({
          scrollTop: $("#lead-form").offset().top -10
        }, 0);
      }
      else{
        $([document.documentElement, document.body]).animate({
          scrollTop: $("#lead-form").offset().top -30
        }, 0);
      }
    }
  },
  mounted() {
    var element = $(".np-green-line")
    this.gsap.to('.np-green-line', {
      duration: 2,
      scrollTrigger: {
        trigger: element, // Элемент, который будет триггером
        start: "top center", // Когда триггер сработает (например, когда верх элемента достигнет центра экрана)
        toggleClass: "active", // Добавляем/убираем класс "active" при срабатывании триггера
        once:true
      }
    });

    var element = $(".new-places")
    this.gsap.to('.new-places', {
      duration: 4,
      scrollTrigger: {
        trigger: element, // Элемент, который будет триггером
        start: "top center", // Когда триггер сработает (например, когда верх элемента достигнет центра экрана)
        toggleClass: "active",
        once:true
      }
    });
  }
}
</script>

<template>
  <div class="new-places left" id="main">
    <span class="sms-cloud-block" style="--sms-color-block:#FF9166">
        <svg width="606" height="455" viewBox="0 0 606 455" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="path-1-inside-1_681_1206" fill="white">
              <path d="M545.416 -0.000183105C578.553 -0.000183105 605.416 26.8628 605.416 59.9998V395C605.416 428.137 578.554 455 545.416 455H3.63861C0.835599 455 -0.638602 451.263 1.10089 449.065C9.21523 438.812 14.4614 423.225 14.6576 405.712L14.6625 404.693V59.9998C14.6626 26.863 41.5257 5.65875e-05 74.6625 -0.000183105H545.416Z"/>
            </mask>
            <path d="M545.416 -0.000183105C578.553 -0.000183105 605.416 26.8628 605.416 59.9998V395C605.416 428.137 578.554 455 545.416 455H3.63861C0.835599 455 -0.638602 451.263 1.10089 449.065C9.21523 438.812 14.4614 423.225 14.6576 405.712L14.6625 404.693V59.9998C14.6626 26.863 41.5257 5.65875e-05 74.6625 -0.000183105H545.416Z" fill="white"/>
            <path class="border" d="M605.416 59.9998L613.416 59.9998L613.416 59.9998L605.416 59.9998ZM14.6576 405.712L22.6571 405.801L22.6574 405.776L22.6576 405.75L14.6576 405.712ZM14.6625 404.693L22.6624 404.732L22.6625 404.712V404.693H14.6625ZM14.6625 59.9998L6.66253 59.9998V59.9998H14.6625ZM74.6625 -0.000183105L74.6625 -8.00018L74.6625 -8.00018L74.6625 -0.000183105ZM1.10089 449.065L7.37403 454.029L1.10089 449.065ZM545.416 -0.000183105V7.99982C574.135 7.99982 597.416 31.2811 597.416 59.9998L605.416 59.9998L613.416 59.9998C613.416 22.4446 582.972 -8.00018 545.416 -8.00018V-0.000183105ZM605.416 59.9998H597.416V395H605.416H613.416V59.9998H605.416ZM605.416 395H597.416C597.416 423.719 574.135 447 545.416 447V455V463C582.972 463 613.416 432.555 613.416 395H605.416ZM545.416 455V447H3.63861V455V463H545.416V455ZM1.10089 449.065L7.37403 454.029C16.798 442.121 22.4452 424.715 22.6571 405.801L14.6576 405.712L6.65815 405.622C6.47761 421.736 1.63245 435.502 -5.17224 444.1L1.10089 449.065ZM14.6576 405.712L22.6576 405.75L22.6624 404.732L14.6625 404.693L6.66262 404.655L6.65774 405.673L14.6576 405.712ZM14.6625 404.693H22.6625V59.9998H14.6625H6.66253V404.693H14.6625ZM14.6625 59.9998L22.6625 59.9998C22.6626 31.2813 45.944 8.00002 74.6626 7.99982L74.6625 -0.000183105L74.6625 -8.00018C37.1075 -7.99991 6.66264 22.4446 6.66253 59.9998L14.6625 59.9998ZM74.6625 -0.000183105V7.99982H545.416V-0.000183105V-8.00018H74.6625V-0.000183105ZM3.63861 455V447C6.22941 447 7.63692 448.781 8.05588 449.791C8.45266 450.748 8.6269 452.446 7.37403 454.029L1.10089 449.065L-5.17224 444.1C-8.16461 447.881 -8.12301 452.547 -6.72325 455.921C-5.30132 459.35 -1.7552 463 3.63861 463V455Z"  mask="url(#path-1-inside-1_681_1206)"/>
        </svg>
        <span class="sms-cloud-block-content">
            <span class="sms-cloud-block-content-txt">
              Наша компания обеспечит высокий <br>доход и безопасность Ваших<br> инвестиций.<br>
              Защитим права собственников и <br>арендаторов, а также обеспечим <br> комплексную подготовку и управление<br> арендными объектами.
            </span>
            <a href="tel:+74997151060" class="btn-num flex phone flex-xy-center">
              +7 (499) 715 - 10 - 60
            </a>
            <span class="btn-num black flex flex-xy-center" @click.prevent="scrollToForm()">
              Заказать звонок
            </span>
        </span>
    </span>
    <span class="sms-cloud-block-mobile" style="--sms-color-block:#FF9166">
      <span class="sms-cloud-block-mobile-content">
        <span class="sms-cloud-title left">Бизнес аренда</span>
        <br>
        <span class="sms-cloud-block-content-txt left">
          Наша компания обеспечит<br>
          высокий доход и безопасность <br>
          ваших инвестиций.<br>
          Защитит права собственников <br>
          и арендаторов, а также<br>
          обеспечит комплексную<br>
          подготовку и управление<br>
          арендными объектами.
        </span>
        <a href="tel:+74997151060" class="btn-num flex phone flex-xy-center left">
          +7 (499) 715 - 10 - 60
        </a>
         <span class="btn-num black flex flex-xy-center" @click.prevent="scrollToForm()">
            Заказать звонок
         </span>
      </span>
    </span>
    <div class="accent-title-box left">
      <div class="orange-title-under-text left"></div>
      <span class="accent-title left">Цивилизованная И Прозрачная Аренда Жилья</span>
      <div class="yellow-line-title mobile left"></div>

    </div>
    <svg class="green-line-arrow mobile left" width="92" height="215" viewBox="0 0 92 215" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M50.2168 211.058C75.1364 181.694 92.2351 147.932 87.488 108.025C83.2029 72.0045 58.691 46.8982 22.7357 67.1638C5.71524 76.7569 -8.21696 99.475 -1.55339 119.171C5.87035 141.113 33.156 126.802 42.0072 114.164C62.6805 84.6453 59.8549 39.6095 29.6282 14.5617C-6.16732 -15.1008 -29.8967 27.1786 -29.5848 27.2409" stroke="#B2DBBF" stroke-width="7" stroke-miterlimit="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

    <svg class="np-green-line mobile-nv" width="800" height="462" viewBox="0 0 800 462" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M64 450C55.9983 423.996 12 388 12 388C12 388 54.4934 409.509 85 345" stroke="#B2DBBF" stroke-width="24" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M788.789 299.848C730.512 109.426 636.643 21.8516 495.743 14.1368C354.843 6.42193 329.372 129.941 388.439 236.74C416.4 287.297 471.165 309.791 499.516 284.963C527.867 260.136 517.757 203.178 491.232 172.772C464.707 142.367 358.227 94.3926 251.84 193.443C145.453 292.493 118.143 433.049 48 404.759" stroke="#B2DBBF" stroke-width="24" stroke-miterlimit="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <svg class="np-blue-line mobile-nv" width="946" height="1130" viewBox="0 0 946 1130" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M26.2472 1012.34C26.2472 1032.3 9.77284 1079.99 12.2547 1083.29M12.2547 1083.29C14.3745 1086.11 40.7673 1048.83 73.2221 1065.3M12.2547 1083.29C69.5931 913.824 546.594 1063.85 692.891 1096.28C839.188 1128.72 992.762 1155.46 1029.71 937.387C1066.66 719.318 775.532 233.063 991.731 12" stroke="#A6CFF2" stroke-width="24" stroke-miterlimit="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <div class="np-container-img-1 left">
      <img src="/assets/main1.png" alt="tittle-img-1">
    </div>
    <div class="np-container-img-2 left">
      <img src="/assets/main2.png?ver=1" alt="tittle-img-2">
<!--      <router-link :to="{path : '/ourprojects', hash: '#heart'}" class="geo-info left flex flex-xy-center">-->
<!--        <div class="circle-white flex flex-xy-center">-->
<!--          <svg width="61" height="62" viewBox="0 0 61 62" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--            <path fill-rule="evenodd" clip-rule="evenodd" d="M42.2753 15.7943C49.9082 22.1867 49.9082 34.2057 42.2753 40.5981L32.4798 51.3723C31.6863 52.2451 30.3137 52.2451 29.5202 51.3723L19.7247 40.5981C12.0918 34.2057 12.0918 22.1867 19.7247 15.7943C27.3577 9.40191 34.6423 9.4019 42.2753 15.7943ZM31 35C34.866 35 38 31.866 38 28C38 24.134 34.866 21 31 21C27.134 21 24 24.134 24 28C24 31.866 27.134 35 31 35Z" fill="#FF9166"/>-->
<!--          </svg>-->
<!--        </div>-->
<!--        <span>ЖК “Сердце столицы”</span>-->
<!--      </router-link>-->

    </div>
    <div class="np-desc-text right">
      <span class="np-text right">Высокий доход и безопасность инвестиции, защита прав собственников и арендаторов</span>
      <div class="green-title-under-text right"></div>
    </div>
  </div>
</template>

<style scoped>

</style>